import api from '@utils/api'

export const getListEvaluators = (status = 'all', type = 'all') => async (dispatch, getState) => {
  const querys = {
    status,
    type
  }
  const response = await api.getListEvaluators(querys)
  return response
}

export const addEvaluator = ({nombre, url}) => async (dispatch, getState) => {
  const data = {
    nombre,
    url,
    tipo: "external"
  }
  const response = await api.addEvaluator(data)
  return response
}

export const updateEvaluator = (newData) => async (dispatch, getState) => {
  const { id, nombre, url, estatus, contacto } = getState().evaluator
  const data = {
    id,
    nombre,
    url,
    estatus,
    contacto,
    ...newData
  }
  data.contacto = JSON.stringify(data.contacto)
  const response = await api.updateEvaluator(data)
  return response
}

export const getListGestors = (id, status = 'all') => async (dispatch, getState) => {
  const querys = {
    status
  }
  const response = await api.getListGestors(id, querys)
  return response
}

export const reassignEvaluatorFolios = (idEvaluator, data) => async () => {
  const response = await api.reassignEvaluatorFolios(idEvaluator, data)
  return response
}

export const addGestor = ({nombre, correo, id_evaluador}) => async (dispatch, getState) => {
  const data = {
    nombre, correo, id_evaluador
  }
  const response = await api.addGestor(data)
  return response
}

export const updateGestor = ({nombre, correo, estatus}) => async (dispatch, getState) => {
  const data = {
    nombre,
    estatus,
    correo
  }
  const response = await api.updateGestor(data, correo)
  return response
}

export const getListCoordinators = (id, status = 'all') => async (dispatch, getState) => {
  const querys = {
    status
  }
  const response = await api.getListCoordinators(id, querys)
  return response
}

export const addCoordinator = ({nombre, correo, id_evaluador}) => async (dispatch, getState) => {
  const data = {
    nombre, correo, id_evaluador
  }
  const response = await api.addCoordinator(data)
  return response
}

export const updateCoordinator = ({nombre, correo, estatus}) => async (dispatch, getState) => {
  const data = {
    nombre,
    estatus
  }
  const response = await api.updateCoordinator(data, correo)
  return response
}
